/* eslint-disable class-methods-use-this */
import Cookies from "universal-cookie";
import { addDays } from "date-fns";

const getExpireTime = (days: number = 365) => {
  const expires = addDays(new Date(), days);

  // expires.setFullYear(expires.getFullYear() + 1);
  return expires;
};

export enum CookieProperties {
  uom = "NITRO_UOM",
  currency = "NITRO_CURRENCY",
  products = "NITRO_PRODUCTS",
  helpGuideShown = "NITRO_HELP_GUIDE_SHOWN",
  caHelpGuideShown = "NITRO_CA_HELP_GUIDE_SHOWN",
}

class Cookie {
  private cookies = new Cookies();

  public uom: string = this.cookies.get(CookieProperties.uom) || "ST";
  public currency: string =
    this.cookies.get(CookieProperties.currency) || "USD";
  public products: string[];
  public helpGuideShown = this.cookies.get(CookieProperties.helpGuideShown);
  public caHelpGuideShown = this.cookies.get(CookieProperties.caHelpGuideShown);

  constructor() {
    this.products = this.cookies.get(CookieProperties.products) || [
      "AMMONIA",
      "ATS",
      "DAP",
      "MAP",
      "UAN",
      "UREA",
    ];

    this.helpGuideShown = this.cookies.get(CookieProperties.helpGuideShown);
  }

  public clearAll = () => {
    this.cookies.remove(CookieProperties.uom);
    this.cookies.remove(CookieProperties.currency);
  };

  public setUom = (uom: string) => {
    this.uom = uom;
    this.cookies.set(CookieProperties.uom, uom, {
      expires: getExpireTime(),
    });
  };

  public setCurrency = (currency: string) => {
    this.currency = currency;
    this.cookies.set(CookieProperties.currency, currency, {
      expires: getExpireTime(),
    });
  };

  public setProducts = (products: string[]) => {
    this.products = products;
    this.cookies.set(CookieProperties.products, JSON.stringify(products), {
      expires: getExpireTime(),
    });
  };

  public setHelpGuideShown = () => {
    this.cookies.set(CookieProperties.helpGuideShown, true, {
      expires: getExpireTime(),
    });
  };

  public setCAHelpGuideShown = () => {
    this.cookies.set(CookieProperties.caHelpGuideShown, true, {
      expires: getExpireTime(),
    });
  };
}

export default new Cookie();
